import React from "react";
import DummyRound from "./dummyRound";

const RoundCreator = ({ selectedSmpSelector, roundsList }) => {
  return (
    <>
      {selectedSmpSelector?.status?.leageData &&
        selectedSmpSelector?.status?.leageData[0].rounds?.length > 0 &&
        selectedSmpSelector?.status?.leageData[0].rounds?.length == 1 && (
          <>
            {roundsList[0].rounds == 16
              ? roundsList?.map(({ rounds }) => {
                  return (
                    rounds == 16 &&
                    selectedSmpSelector?.status?.leageData[0]?.rounds?.length ==
                      1 && (
                      <>
                        <DummyRound
                          rounds={8}
                          divider2Height="79px"
                          divider2Style="58px"
                          divider3Style="125%"
                        />

                        <DummyRound
                          rounds={4}
                          divider2Height="157px"
                          divider2Style="136px"
                          divider3Style="240%"
                          divider2Padding={0.15}
                        />

                        <DummyRound
                          rounds={2}
                          divider2Height="313px"
                          divider2Style="292px"
                          divider2Padding={0.15}
                          divider3Style="450%"
                        />

                        <DummyRound rounds={1} />
                      </>
                    )
                  );
                })
              : roundsList[0].rounds == 32
              ? roundsList?.map(({ rounds }) => {
                  return (
                    rounds == 32 &&
                    selectedSmpSelector?.status?.leageData[0]?.rounds?.length ==
                      1 && (
                      <>
                        <DummyRound
                          rounds={16}
                          divider2Height="79px"
                          divider2Style="58px"
                          divider3Style="125%"
                        />

                        <DummyRound
                          rounds={8}
                          divider2Padding={0.15}
                          divider2Height="157px"
                          divider2Style="136px"
                          divider3Style="240%"
                        />

                        <DummyRound
                          rounds={4}
                          divider2Padding={0.15}
                          divider2Height="313px"
                          divider2Style="292px"
                          divider3Style="470%"
                        />

                        <DummyRound
                          rounds={2}
                          divider2Height="625px"
                          divider2Style="605px"
                          divider2Padding={0.15}
                          divider3Style="850%"
                        />

                        <DummyRound rounds={1} />
                      </>
                    )
                  );
                })
              : roundsList[0].rounds == 64
              ? roundsList?.map(({ rounds }) => {
                  return (
                    rounds == 64 &&
                    selectedSmpSelector?.status?.leageData[0]?.rounds?.length ==
                      1 && (
                      <>
                        <DummyRound
                          rounds={32}
                          divider2Height="79px"
                          divider2Style="58px"
                          divider3Style="125%"
                        />

                        <DummyRound
                          rounds={16}
                          // divider2Padding={0.15}
                          divider2Height="157px"
                          divider2Style="136px"
                          divider3Style="240%"
                        />

                        <DummyRound
                          rounds={8}
                          // divider2Padding={0.15}
                          divider2Height="313px"
                          divider2Style="292px"
                          divider3Style="470%"
                        />

                        <DummyRound
                          rounds={4}
                          divider2Height="625px"
                          divider2Style="605px"
                          // divider2Padding={0.15}
                          divider3Style="910%"
                        />

                        <DummyRound
                          rounds={2}
                          divider2Height="1250px"
                          divider2Style="1230px"
                          // divider2Padding={0.15}
                          divider3Style="1800%"
                        />

                        <DummyRound rounds={1} />
                      </>
                    )
                  );
                })
              : roundsList[0].rounds == 128
              ? roundsList?.map(({ rounds }) => {
                  return (
                    rounds == 128 &&
                    selectedSmpSelector?.status?.leageData[0]?.rounds?.length ==
                      1 && (
                      <>
                        <DummyRound
                          rounds={64}
                          divider2Height="79px"
                          divider2Style="58px"
                          divider3Style="125%"
                        />

                        <DummyRound
                          rounds={32}
                          divider2Padding={0.15}
                          divider2Height="157px"
                          divider2Style="136px"
                          divider3Style="240%"
                        />

                        <DummyRound
                          rounds={16}
                          divider2Padding={0.15}
                          divider2Height="313px"
                          divider2Style="292px"
                          divider3Style="470%"
                        />

                        <DummyRound
                          rounds={8}
                          divider2Height="625px"
                          divider2Style="605px"
                          divider2Padding={0.15}
                          divider3Style="910%"
                        />

                        <DummyRound
                          rounds={4}
                          divider2Height="1250px"
                          divider2Style="1230px"
                          divider2Padding={0.15}
                          divider3Style="1800%"
                        />

                        <DummyRound
                          rounds={2}
                          divider2Height="2495px"
                          divider2Style="2475px"
                          divider2Padding={0.15}
                          divider3Style="3587%"
                        />

                        <DummyRound rounds={1} />
                      </>
                    )
                  );
                })
              : roundsList[0].rounds == 8
              ? roundsList?.map(({ rounds }) => {
                  return (
                    rounds == 8 &&
                    selectedSmpSelector?.status?.leageData[0]?.rounds?.length ==
                      1 && (
                      <>
                        <DummyRound
                          rounds={4}
                          divider2Height="79px"
                          divider2Style="58px"
                          divider3Style="125%"
                        />

                        <DummyRound
                          rounds={2}
                          divider2Height="157px"
                          divider2Style="136px"
                          divider3Style="240%"
                          divider2Padding={0.15}
                        />

                        <DummyRound rounds={1} />
                      </>
                    )
                  );
                })
              : roundsList[0].rounds == 4
              ? roundsList?.map(({ rounds }) => {
                  return (
                    rounds == 4 &&
                    selectedSmpSelector?.status?.leageData[0]?.rounds?.length ==
                      1 && (
                      <>
                        <DummyRound
                          rounds={2}
                          divider2Height="79px"
                          divider2Style="58px"
                          divider3Style="125%"
                        />

                        <DummyRound rounds={1} />
                      </>
                    )
                  );
                })
              : null}
          </>
        )}

      {selectedSmpSelector?.status?.leageData &&
        selectedSmpSelector?.status?.leageData[0].rounds?.length > 0 &&
        selectedSmpSelector?.status?.leageData[0].rounds?.length == 2 && (
          <>
            {roundsList[0].rounds == 16
              ? roundsList?.map(({ rounds }) => {
                  return (
                    rounds == 16 &&
                    selectedSmpSelector?.status?.leageData[0]?.rounds?.length ==
                      2 && (
                      <>
                        <DummyRound
                          rounds={4}
                          divider2Height="157px"
                          divider2Style="136px"
                          divider3Style="240%"
                          divider2Padding={0.15}
                        />

                        <DummyRound
                          rounds={2}
                          divider2Height="313px"
                          divider2Style="292px"
                          divider2Padding={0.15}
                          divider3Style="450%"
                        />

                        <DummyRound rounds={1} />
                      </>
                    )
                  );
                })
              : roundsList[0].rounds == 32
              ? roundsList?.map(({ rounds }) => {
                  return (
                    rounds == 32 &&
                    selectedSmpSelector?.status?.leageData[0]?.rounds?.length ==
                      2 && (
                      <>
                        <DummyRound
                          rounds={8}
                          divider2Padding={0.15}
                          divider2Height="157px"
                          divider2Style="136px"
                          divider3Style="240%"
                        />

                        <DummyRound
                          rounds={4}
                          divider2Padding={0.15}
                          divider2Height="313px"
                          divider2Style="292px"
                          divider3Style="470%"
                        />

                        <DummyRound
                          rounds={2}
                          divider2Height="625px"
                          divider2Style="605px"
                          divider2Padding={0.15}
                          divider3Style="850%"
                        />

                        <DummyRound rounds={1} />
                      </>
                    )
                  );
                })
              : roundsList[0].rounds == 64
              ? roundsList?.map(({ rounds }) => {
                  return (
                    rounds == 64 &&
                    selectedSmpSelector?.status?.leageData[0]?.rounds?.length ==
                      2 && (
                      <>
                        <DummyRound
                          rounds={16}
                          // divider2Padding={0.15}
                          divider2Height="157px"
                          divider2Style="136px"
                          divider3Style="240%"
                        />

                        <DummyRound
                          rounds={8}
                          // divider2Padding={0.15}
                          divider2Height="313px"
                          divider2Style="292px"
                          divider3Style="470%"
                        />

                        <DummyRound
                          rounds={4}
                          divider2Height="625px"
                          divider2Style="605px"
                          // divider2Padding={0.15}
                          divider3Style="910%"
                        />

                        <DummyRound
                          rounds={2}
                          divider2Height="1250px"
                          divider2Style="1230px"
                          // divider2Padding={0.15}
                          divider3Style="1800%"
                        />

                        <DummyRound rounds={1} />
                      </>
                    )
                  );
                })
              : roundsList[0].rounds == 128
              ? roundsList?.map(({ rounds }) => {
                  return (
                    rounds == 128 &&
                    selectedSmpSelector?.status?.leageData[0]?.rounds?.length ==
                      2 && (
                      <>
                        <DummyRound
                          rounds={32}
                          divider2Padding={0.15}
                          divider2Height="157px"
                          divider2Style="136px"
                          divider3Style="240%"
                        />

                        <DummyRound
                          rounds={16}
                          divider2Padding={0.15}
                          divider2Height="313px"
                          divider2Style="292px"
                          divider3Style="470%"
                        />

                        <DummyRound
                          rounds={8}
                          divider2Height="625px"
                          divider2Style="605px"
                          divider2Padding={0.15}
                          divider3Style="910%"
                        />

                        <DummyRound
                          rounds={4}
                          divider2Height="1250px"
                          divider2Style="1230px"
                          divider2Padding={0.15}
                          divider3Style="1800%"
                        />

                        <DummyRound
                          rounds={2}
                          divider2Height="2495px"
                          divider2Style="2475px"
                          divider2Padding={0.15}
                          divider3Style="3587%"
                        />

                        <DummyRound rounds={1} />
                      </>
                    )
                  );
                })
              : roundsList[0].rounds == 8
              ? roundsList?.map(({ rounds }) => {
                  return (
                    rounds == 8 &&
                    selectedSmpSelector?.status?.leageData[0]?.rounds?.length ==
                      2 && (
                      <>
                        <DummyRound
                          rounds={2}
                          divider2Height="157px"
                          divider2Style="136px"
                          divider3Style="240%"
                          divider2Padding={0.15}
                        />

                        <DummyRound rounds={1} />
                      </>
                    )
                  );
                })
              : roundsList[0].rounds == 4
              ? roundsList?.map(({ rounds }) => {
                  return (
                    rounds == 4 &&
                    selectedSmpSelector?.status?.leageData[0]?.rounds?.length ==
                      2 && <DummyRound rounds={1} />
                  );
                })
              : null}
          </>
        )}

      {selectedSmpSelector?.status?.leageData &&
        selectedSmpSelector?.status?.leageData[0].rounds?.length > 0 &&
        selectedSmpSelector?.status?.leageData[0].rounds?.length == 3 && (
          <>
            {roundsList[0].rounds == 16
              ? roundsList?.map(({ rounds }) => {
                  return (
                    rounds == 16 &&
                    selectedSmpSelector?.status?.leageData[0]?.rounds?.length ==
                      3 && (
                      <>
                        <DummyRound
                          rounds={2}
                          divider2Height="313px"
                          divider2Style="292px"
                          divider2Padding={0.15}
                          divider3Style="450%"
                        />

                        <DummyRound rounds={1} />
                      </>
                    )
                  );
                })
              : roundsList[0].rounds == 32
              ? roundsList?.map(({ rounds }) => {
                  return (
                    rounds == 32 &&
                    selectedSmpSelector?.status?.leageData[0]?.rounds?.length ==
                      3 && (
                      <>
                        <DummyRound
                          rounds={4}
                          divider2Padding={0.15}
                          divider2Height="313px"
                          divider2Style="292px"
                          divider3Style="470%"
                        />

                        <DummyRound
                          rounds={2}
                          divider2Height="625px"
                          divider2Style="605px"
                          divider2Padding={0.15}
                          divider3Style="910%"
                        />

                        <DummyRound rounds={1} />
                      </>
                    )
                  );
                })
              : roundsList[0].rounds == 64
              ? roundsList?.map(({ rounds }) => {
                  return (
                    rounds == 64 &&
                    selectedSmpSelector?.status?.leageData[0]?.rounds?.length ==
                      3 && (
                      <>
                        <DummyRound
                          rounds={8}
                          // divider2Padding={0.15}
                          divider2Height="313px"
                          divider2Style="292px"
                          divider3Style="470%"
                        />

                        <DummyRound
                          rounds={4}
                          divider2Height="625px"
                          divider2Style="605px"
                          // divider2Padding={0.15}
                          divider3Style="910%"
                        />

                        <DummyRound
                          rounds={2}
                          divider2Height="1250px"
                          divider2Style="1230px"
                          // divider2Padding={0.15}
                          divider3Style="1800%"
                        />

                        <DummyRound rounds={1} />
                      </>
                    )
                  );
                })
              : roundsList[0].rounds == 128
              ? roundsList?.map(({ rounds }) => {
                  return (
                    rounds == 128 &&
                    selectedSmpSelector?.status?.leageData[0]?.rounds?.length ==
                      3 && (
                      <>
                        <DummyRound
                          rounds={16}
                          divider2Padding={0.15}
                          divider2Height="313px"
                          divider2Style="292px"
                          divider3Style="470%"
                        />

                        <DummyRound
                          rounds={8}
                          divider2Height="625px"
                          divider2Style="605px"
                          divider2Padding={0.15}
                          divider3Style="910%"
                        />

                        <DummyRound
                          rounds={4}
                          divider2Height="1250px"
                          divider2Style="1230px"
                          divider2Padding={0.15}
                          divider3Style="1800%"
                        />

                        <DummyRound
                          rounds={2}
                          divider2Height="2495px"
                          divider2Style="2475px"
                          divider2Padding={0.15}
                          divider3Style="3587%"
                        />

                        <DummyRound rounds={1} />
                      </>
                    )
                  );
                })
              : roundsList[0].rounds == 8
              ? roundsList?.map(({ rounds }) => {
                  return (
                    rounds == 8 &&
                    selectedSmpSelector?.status?.leageData[0]?.rounds?.length ==
                      3 && <DummyRound rounds={1} />
                  );
                })
              : null}
          </>
        )}

      {/*  */}
      {selectedSmpSelector?.status?.leageData &&
        selectedSmpSelector?.status?.leageData[0].rounds?.length > 0 &&
        selectedSmpSelector?.status?.leageData[0].rounds?.length == 4 && (
          <>
            {roundsList[0].rounds == 32
              ? roundsList?.map(({ rounds }) => {
                  return (
                    rounds == 32 &&
                    selectedSmpSelector?.status?.leageData[0]?.rounds?.length ==
                      4 && (
                      <>
                        <DummyRound
                          rounds={2}
                          divider2Height="625px"
                          divider2Style="605px"
                          divider2Padding={0.15}
                          divider3Style="910%"
                        />

                        <DummyRound rounds={1} />
                      </>
                    )
                  );
                })
              : roundsList[0].rounds == 64
              ? roundsList?.map(({ rounds }) => {
                  return (
                    rounds == 64 &&
                    selectedSmpSelector?.status?.leageData[0]?.rounds?.length ==
                      4 && (
                      <>
                        <DummyRound
                          rounds={4}
                          divider2Height="625px"
                          divider2Style="605px"
                          // divider2Padding={0.15}
                          divider3Style="910%"
                        />

                        <DummyRound
                          rounds={2}
                          divider2Height="1250px"
                          divider2Style="1230px"
                          divider3Style="1800%"
                        />

                        <DummyRound rounds={1} />
                      </>
                    )
                  );
                })
              : roundsList[0].rounds == 128
              ? roundsList?.map(({ rounds }) => {
                  return (
                    rounds == 128 &&
                    selectedSmpSelector?.status?.leageData[0]?.rounds?.length ==
                      4 && (
                      <>
                        <DummyRound
                          rounds={8}
                          divider2Height="625px"
                          divider2Style="605px"
                          divider3Style="910%"
                        />

                        <DummyRound
                          rounds={4}
                          divider2Height="1250px"
                          divider2Style="1230px"
                          divider3Style="1800%"
                        />

                        <DummyRound
                          rounds={2}
                          divider2Height="2495px"
                          divider2Style="2475px"
                          divider3Style="3587%"
                        />

                        <DummyRound rounds={1} />
                      </>
                    )
                  );
                })
              : roundsList[0].rounds == 16
              ? roundsList?.map(({ rounds }) => {
                  return (
                    rounds == 16 &&
                    selectedSmpSelector?.status?.leageData[0]?.rounds?.length ==
                      4 && <DummyRound rounds={1} />
                  );
                })
              : null}
          </>
        )}

      {selectedSmpSelector?.status?.leageData &&
        selectedSmpSelector?.status?.leageData[0].rounds?.length > 0 &&
        selectedSmpSelector?.status?.leageData[0].rounds?.length == 5 && (
          <>
            {roundsList[0].rounds == 64
              ? roundsList?.map(({ rounds }) => {
                  return (
                    rounds == 64 &&
                    selectedSmpSelector?.status?.leageData[0]?.rounds?.length ==
                      5 && (
                      <>
                        <DummyRound
                          rounds={2}
                          divider2Height="1250px"
                          divider2Style="1230px"
                          divider3Style="1800%"
                        />

                        <DummyRound rounds={1} />
                      </>
                    )
                  );
                })
              : roundsList[0].rounds == 128
              ? roundsList?.map(({ rounds }) => {
                  return (
                    rounds == 128 &&
                    selectedSmpSelector?.status?.leageData[0]?.rounds?.length ==
                      5 && (
                      <>
                        <DummyRound
                          rounds={4}
                          divider2Height="1250px"
                          divider2Style="1230px"
                          divider2Padding={0.15}
                          divider3Style="1800%"
                        />

                        <DummyRound
                          rounds={2}
                          divider2Height="2495px"
                          divider2Style="2475px"
                          divider2Padding={0.15}
                          divider3Style="3587%"
                        />

                        <DummyRound rounds={1} />
                      </>
                    )
                  );
                })
              : roundsList[0].rounds == 32
              ? roundsList?.map(({ rounds }) => {
                  return (
                    rounds == 32 &&
                    selectedSmpSelector?.status?.leageData[0]?.rounds?.length ==
                      5 && <DummyRound rounds={1} />
                  );
                })
              : null}
          </>
        )}

      {selectedSmpSelector?.status?.leageData &&
        selectedSmpSelector?.status?.leageData[0].rounds?.length > 0 &&
        selectedSmpSelector?.status?.leageData[0].rounds?.length == 6 && (
          <>
            {roundsList[0].rounds == 128
              ? roundsList?.map(({ rounds }) => {
                  return (
                    rounds == 128 &&
                    selectedSmpSelector?.status?.leageData[0]?.rounds?.length ==
                      6 && (
                      <>
                        <DummyRound
                          rounds={2}
                          divider2Height="2495px"
                          divider2Style="2475px"
                          divider2Padding={0.15}
                          divider3Style="3587%"
                        />

                        <DummyRound rounds={1} />
                      </>
                    )
                  );
                })
              : roundsList[0].rounds == 64
              ? roundsList?.map(({ rounds }) => {
                  return (
                    rounds == 64 &&
                    selectedSmpSelector?.status?.leageData[0]?.rounds?.length ==
                      6 && <DummyRound rounds={1} />
                  );
                })
              : null}
          </>
        )}

      {selectedSmpSelector?.status?.leageData &&
        selectedSmpSelector?.status?.leageData[0].rounds?.length > 0 &&
        selectedSmpSelector?.status?.leageData[0].rounds?.length == 7 && (
          <>
            {roundsList[0].rounds == 128
              ? roundsList?.map(({ rounds }) => {
                  return (
                    rounds == 128 &&
                    selectedSmpSelector?.status?.leageData[0]?.rounds?.length ==
                      7 && <DummyRound rounds={1} />
                  );
                })
              : null}
          </>
        )}
    </>
  );
};

export default RoundCreator;
